import React from 'react';
import Card from '../../../Presentation/components/ui/Card';
import Button from '../../../Presentation/components/ui/Button';
import AppInput from '../../../Presentation/components/ui/AppInput';
import {Plus} from 'lucide-react';
import ProductsTableV2 from './ProductsTableV2';
import {Product} from '../models/product.model';
import {PAGINATION_CONFIG} from '../../../constants/appConfig';
import {PERMISSIONS} from '../../../constants/permissions';

interface ProductsTabContentProps {
  searchQuery: string;
  onSearchChange: (value: string) => void;
  filteredProducts: Product[];
  pagination: {page?: number; limit?: number; total?: number};
  onPageChange: (page: number) => void;
  onPageSizeChange: (size: number) => void;
  onAddStock: (product: Product) => void;
  onViewDetails: (product: Product) => void;
  onEditProduct: (product: Product) => void;
  onAddProduct: () => void;
  currentUserId: number;
  loading: boolean;
}

export const ProductsTabContent: React.FC<ProductsTabContentProps> = ({
  searchQuery,
  onSearchChange,
  filteredProducts,
  pagination,
  onPageChange,
  onPageSizeChange,
  onAddStock,
  onViewDetails,
  onEditProduct,
  onAddProduct,
  currentUserId,
  loading
}) => (
  <div className="space-y-6">
    <Card className="p-6">
      <div className="flex flex-col sm:flex-row gap-4 items-center justify-between mb-6">
        <div className="flex-1 w-full">
          <AppInput
            type="text"
            placeholder="البحث في المنتجات..."
            value={searchQuery}
            onChange={(e) => onSearchChange(e.target.value)}
            className="border border-gray-300 focus:ring-2 focus:ring-primary/30 focus:border-brand-500"
          />
        </div>
        <Button
          variant="primary"
          permission={PERMISSIONS.MANAGE_PRODUCTS}
          onClick={onAddProduct}
          className="flex items-center gap-2 flex-shrink-0"
        >
          <Plus className="w-4 h-4" />
          إضافة منتج جديد
        </Button>
      </div>

      <ProductsTableV2
        data={filteredProducts}
        page={pagination?.page || 1}
        pageSize={pagination?.limit || PAGINATION_CONFIG.DEFAULT_PAGE_SIZE}
        totalCount={pagination?.total || 0}
        onPageChange={onPageChange}
        onPageSizeChange={onPageSizeChange}
        onAddStock={onAddStock}
        onViewDetails={onViewDetails}
        onEditProduct={onEditProduct}
        currentUserId={currentUserId}
        showPageSizeSelector={true}
        showPaginationInfo={true}
        exportable={true}
        loading={loading}
      />
    </Card>
  </div>
);
